import { useCallback } from "react";
import { useApiBase } from "../../base/api-base";

export function useDeleteLojaById() {
    const { invocarApi, ...outrasPropriedades } = useApiBase();

    const deleteLojaById = useCallback(
        (lojaid: string) => {
            return invocarApi({
                url: `/api/v2/loja/${lojaid}`,
                method: "DELETE",
                enviarTokenUsuario: true,
            });
        },
        [invocarApi]
    );
    return {
        ...outrasPropriedades,
        deleteLojaById,
    };
}
